import { render, staticRenderFns } from "./hall-program-item.vue?vue&type=template&id=008ddf5a&"
import script from "./hall-program-item.vue?vue&type=script&lang=js&"
export * from "./hall-program-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports